import * as React from 'react';
import Managers from '@ui/scenes/Managers';

const ManagersPage = () => <Managers />;

export default ManagersPage;



// WEBPACK FOOTER //
// ./src/pages/Managers/Managers.tsx